import React, { Component } from 'react'
import { SubmitButton } from "../button/button-style"
import { EmailText } from "../text-block/text-container-style"
import { AlertMessage, ErrorContainer, FlexBox } from "../utility-styles/utility-styles"
import { TextInput } from "../input/input-style"

export default class NewsLetterForm extends Component {

    constructor(props) {
        super(props)
        this.emailInput = React.createRef();

        this.state ={
            displayAlert: "false",
            messageContent: "Please enter a valid email address!",
            emailValid:false
        }
    }

    render() {
        return (
            <FlexBox direction="column" horizontal="center" styles="margin: 40px auto 40px; width:85vw; min-width:240px; max-width:680px;">
                <EmailText styles="margin:0; height:auto; border-radius:0px;"><p>Join our email newsletter for weekly updates and free content!</p></EmailText>
                <FlexBox direction="row" horizontal="center" styles="margin: 10px 40px 10px; width:85vw; max-width:680px;">
                    <TextInput placeholder="Email Address" type="email" ref={this.emailInput}></TextInput>
                    <SubmitButton onClick={this.subscribeEmail.bind(this)}>Submit</SubmitButton>
                </FlexBox>
                    <AlertMessage display={this.state.displayAlert} emailValid={this.state.emailValid}>{this.state.messageContent}</AlertMessage>
            </FlexBox>
        )
    }

    /**Post request to add user email to db.  */
    subscribeEmail() {

        if (this.validateEmail(this.emailInput.current.value)) {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({ email: this.emailInput.current.value }),
                headers: { 'Content-Type': 'application/json' }
            };
            //Displays an alery after succesfull subscription
            fetch('/api/subscribe', requestOptions).then((res) => {return res.text()}).then((resText) => this.setState({displayAlert:"true", messageContent: resText, emailValid:true}));

        }
        else {
            this.setState({displayAlert:"true"})
        }
    }

    /**Checks to see if email fits pattern email.adc.abc*/
    validateEmail(email) {
        let re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
}
//"You have subscribed to our newsletter!"